export default {
    lockTooltip: 'Period change is available after access payment',
    title: 'Show for the period',
    period: {
        minutes: {
            short: '10 m.',
            full: '10 minutes'
        },
        hour: {
            short: '1 h.',
            full: '1 hour'
        },
        day: {
            short: '1 day',
            full: '1 day'
        },
        week: {
            short: '1 week',
            full: '1 week'
        },
        month: {
            short: '1 мo.',
            full: '1 month'
        },
        quarter: {
            short: '3 mos.',
            full: '3 months'
        },
        halfYear: {
            short: '6 mos.',
            full: '6 months'
        },
        year: {
            short: '1 yr.',
            full: '1 year'
        }
    }
};
